import { NavLink } from 'react-router-dom';
import { Tooltip } from 'tdesign-react';

import Cover, { CoverProps } from '../cover';
import styles from './index.module.less';

interface IProps {
  coverProps: CoverProps;
  nameProps?: {
    title?: string;
    subTitle?: string;
    link?: string;
    onClick?: () => void;
  };
}

/**
 * 名称封面图
 * @param param0
 * @returns
 */
export const CoverName: React.FC<IProps> = ({ coverProps, nameProps }) => {
  const { title, subTitle, link = '', onClick } = nameProps || {};

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <Cover {...coverProps} />
      </div>
      <div className={styles.right}>
        <div>
          <Tooltip content={title} destroyOnClose showArrow>
            {link ? (
              <NavLink to={link} className={styles.title}>
                {title}
              </NavLink>
            ) : null}
            {onClick ? (
              <span className={styles.click} onClick={onClick}>
                {title}
              </span>
            ) : null}
          </Tooltip>
        </div>
        <div>
          <Tooltip content={subTitle} destroyOnClose showArrow>
            <span className={styles.subtitle}>{subTitle}</span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
